export default "<div class=\"modal-body\">\n  <sync-orders-modal-main\n    step=\"$ctrl.step\"\n  >\n  </sync-orders-modal-main>\n</div>\n"